import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Login.module.css';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Credenziali non valide';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginBox}>
        <div className={styles.header}>
          <h1>Turna</h1>
          <p>Sistema di Gestione Turni</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <h2>Accedi</h2>

          {error && (
            <div className={styles.error}>
  {error}
            </div>
          )}

          <div className={styles.inputGroup}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="mario.rossi@esempio.com"
              required
              disabled={isLoading}
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            className={styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? 'Accesso in corso...' : 'Accedi'}
          </button>

          <div className={styles.demoCredentials}>
            <p><strong>Credenziali Demo:</strong></p>
            <p>SuperAdmin: admin@turna.com / Demo123!</p>
            <p>Owner: Apuleio_Poletti@gmail.com / Demo123!</p>
            <p>Manager: Orio53@email.it / Demo123!</p>
            <p>Employee: Antigone.Serafini7@hotmail.com / Demo123!</p>
          </div>
        </form>
      </div>
    </div>
  );
};

Login.displayName = 'Login';
